export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10143.a878d447.jpg";